import React from 'react';
import stylesOp from "../../../../../pages/OperationDetailPage/_components/Operation/style.module.scss";
import { getStatusOpName, InfoMode, OP_STATUS, OPERATION_TYPE, STEP_KEY_V2 } from "../../../../../util/varibles/constants";
import { getStepNameOfOp } from "../../../../../util/varibles/global";
import { IHarvest2, IOperation2 } from "../../../../../util/varibles/interface";
import DeadFish from '../../../../Operation/DeadFish';
import SiteDisease from "../../../../Operation/FishDisease/SiteDisease";
import Invoices from '../../../../Operation/Invoices';
import TankDensities from "../../../../Operation/TankDensities";
import ActivityLog from "../../_component/AcitivtyLog";
import ApproveControl from "../../_component/ApproveControl";
import Approver from "../../_component/Approver";
import BoxOpInfo from "../../_component/BoxOpInfo";
import Columns from "../../_component/Columns";
import Duration from "../../_component/Duration";
import Status from "../../_component/Status";
import Header from "../../Header";
import { callEventPopupOpInfo, usePopupOpInfo } from '../../PopupOpInfoContext';
import stylesContainer from "../../style.module.scss";
import HarvestInfo from "./HarvestInfo";

interface IProps {
    isEdit: boolean
    isApprove: boolean
    data: IOperation2<IHarvest2>
}

const Harvest: React.FC<IProps> = (props) => {
    const {
        data,
        isEdit,
        isApprove,
    } = props;
    const [summary] = usePopupOpInfo(state => state.data?.operation.summary);
    const [infoMode] = usePopupOpInfo(state => state.infoMode);
    const { updateNote, changeState } = callEventPopupOpInfo();
    const { operation, activity_log } = data;

    const { current_process, status } = operation;
    const statusText = status === OP_STATUS.PROCESSING ? getStepNameOfOp[OPERATION_TYPE.HARVEST]({
        current_process,
        operation,
        activity_log
    }) : getStatusOpName(status);
    const totalDischargedFish = (summary ?? operation.summary ?? []).reduce((unitTotal, item) => {
        return unitTotal + item.actual.tanks.reduce((tankTotal, tank) => {
            return tankTotal + tank.discharge.reduce((dischargeTotal, discharge) => {
                return dischargeTotal + discharge.fish_amount;
            }, 0);
        }, 0);
    }, 0);
    const totalDeadFish = operation.dead_fish ?? (activity_log.reduce((total, step) => {
        if (step.key !== STEP_KEY_V2.DISCHARGING)
            return total;

        return total + (step.real_sub_steps || []).reduce((stepTotal, subStep) => {
            return stepTotal + (subStep.dead_fish || 0);
        }, 0);
    }, 0) || undefined);

    return <>
        <Header operation={operation}>
            <div className={stylesContainer.title}>
                <div className={stylesContainer['header-id']}>
                    <Status {...{ status, statusText }} />
                    <div>
                        Total weight:
                        <b className='ml-5'>{Math.round((operation as IHarvest2).total_weight / 1000) / 1000} t</b>
                    </div>
                </div>
            </div>
        </Header>

        <div className={stylesContainer.body}>
            <ActivityLog />
            <BoxOpInfo data={data} isEdit={isEdit} handleUpdateNote={updateNote}>
                <Columns className="mb-2" content={[
                    <>
                        <Duration activity_log={activity_log} />
                        <ApproveControl {...{ isApprove, operation, handleChangeState: changeState }} />
                        <Approver operation={operation} />
                        <SiteDisease diseases={operation.diseases || []} />
                    </>,
                    infoMode === InfoMode.ACTUAL && <div className='flex flex-col gap-1 [&>div]:!items-end [&>div]:!leading-[20px]'>
                        <DeadFish
                            value={totalDeadFish}
                            total={totalDischargedFish}
                            valueClassName='w-full text-right text-[15px] font-semibold !leading-[20px]'
                            layout='vertical'
                            label='Σ Dead fish'
                            showPercent={operation.status === OP_STATUS.FINISHED}
                        />
                    </div>
                ]} />
                <div className="h-[28px] flex items-center mb-1">
                    <Invoices operation={operation} />
                </div>
                <div className={stylesOp['info-line']}>
                    <TankDensities type={OPERATION_TYPE.HARVEST} storages={operation.sub_operations[0]?.storages} />
                </div>
                <HarvestInfo operation={{ ...operation, summary }} infoMode={infoMode} />
            </BoxOpInfo>
        </div>
    </>
};

export default Harvest;
